<template>
  <InputTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :data="data"
    :actions="actions"
    :sortBy="sortBy"
    type="replacement"
  >
    <template v-slot:toolbar-right>
      <ReplacementCreateDropdown />
    </template>
  </InputTableContainer>
</template>

<script>
import { get } from 'vuex-pathify'
import InputTableContainer from '@/components/InputTableContainer'
import replacementTypes from '../../../common/replacementTypes'
import replacementStatus from '../../../common/replacementStatus'
import ReplacementCreateDropdown from './ReplacementCreateDropdown'
import ReplacementEditModal from './ReplacementEditModal'
import ReplacementDeleteModal from './ReplacementDeleteModal'

export default {
  name: 'ReplacementContainer',

  components: {
    InputTableContainer,
    ReplacementCreateDropdown
  },

  data: () => ({
    actions: [
      {
        title: 'Redigera',
        icon: 'mdi-pencil',
        component: ReplacementEditModal,
        type: 'edit'
      },
      {
        title: 'Ta bort',
        icon: 'mdi-delete',
        component: ReplacementDeleteModal,
        type: 'delete'
      }
    ],
    sortBy: ['train_number', 'from', 'to'],
    headers: [
      {
        text: 'Typ',
        value: '_type'
      },
      {
        text: 'Tågnr.',
        value: 'train_number'
      },
      {
        text: 'Från',
        value: '_from'
      },
      {
        text: 'Till',
        value: '_to'
      },
      {
        text: 'Via',
        value: 'via'
      },
      {
        text: 'Status',
        value: '_status'
      },
      {
        text: '',
        value: 'actions',
        sortable: false,
        filterable: false,
        align: 'right'
      }
    ]
  }),

  computed: {
    replacements: get('replacement/data'),
    stops: get('event/stops'),

    data() {
      if (!Object.values(this.replacements).length) {
        return []
      }

      return Object.values(this.replacements).map(x => ({
        ...x,
        _from: this.stops.find(y => y.short_name === x.from).stop_name,
        _to: this.stops.find(y => y.short_name === x.to).stop_name,
        _type: replacementTypes[x.type],
        _status: replacementStatus[x.status]
      }))
    }
  },

  beforeDestroy() {
    this.$store.set('replacement/data', {})
  }
}
</script>
